import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const WhatsappIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M5.05,20.08a1.67,1.67,0,0,1-1.24-.52,1.67,1.67,0,0,1-.52-1.24V7.74a1.69,1.69,0,0,1,.52-1.25A1.67,1.67,0,0,1,5.05,6H19.16a1.67,1.67,0,0,1,1.24.52,1.69,1.69,0,0,1,.52,1.25V18.32a1.78,1.78,0,0,1-1.76,1.76Zm7.06-6.17L5.05,9.5v8.82H19.16V9.5Zm0-1.77,7.05-4.4H5.05ZM5.05,9.5v0Z" />{' '}
    </SvgIcon>
  )
}
export default WhatsappIcon
